import "core-js/stable";
import "regenerator-runtime/runtime";

import { Power2, gsap } from "gsap";

import { Scroll } from './_app/cuchillo/scroll/Scroll';
import { VSticky } from './_app/cuchillo/scroll/insiders/VSticky';
import { VScaleZero } from './_app/cuchillo/scroll/insiders/VScaleZero';
import { VScale } from './_app/cuchillo/scroll/insiders/VScale';
import { VInsider } from './_app/cuchillo/scroll/insiders/VInsider';
import { VDisplace } from './_app/cuchillo/scroll/insiders/VDisplace';
import { VInsiderMask } from './_app/cuchillo/scroll/insiders/VInsiderMask';

import { ScrollItem__BlockLanding } from './scroll/ScrollItem__BlockLanding';
import { ScrollItem__BlockDefault } from './scroll/ScrollItem__BlockDefault';
import { ScrollItem__BlockCarsFeatured } from './scroll/ScrollItem__BlockCarsFeatured';
import { ScrollItem__SliderDefault } from './scroll/ScrollItem__SliderDefault';
import { ScrollItem__SliderThumbnails } from './scroll/ScrollItem__SliderThumbnails';
import { ScrollItem__CarList } from './scroll/ScrollItem__CarList';
import { ScrollItem__BlockBillboard } from './scroll/ScrollItem__BlockBillboard';

import { Accessibility } from './_app/cuchillo/core/Accessibility';
import { Basics, isDebug, isTouch } from './_app/cuchillo/core/Basics';
import EventDispatcher from './_app/cuchillo/core/EventDispatcher';
import { Interaction, MrInteraction } from './_app/cuchillo/core/Interaction';
import { GetBy } from "./_app/cuchillo/core/Element";
import { Metrics } from './_app/cuchillo/core/Metrics';
// import { Statics } from './_app/cuchillo/utils/Statics';
import Keyboard from './_app/cuchillo/core/Keyboard';

import LoaderController from './_app/cuchillo/loaders/LoaderController';
import PagesLoader from './_app/cuchillo/loaders/PagesLoader';
import MediaLoader from './_app/cuchillo/loaders/MediaLoader';

import { ControllerPage } from './_app/cuchillo/pages/ControllerPage';
import Page from './_app/cuchillo/pages/Page';
import Default from './pages/Default';
import Legal from './pages/Legal';

import BG from './_app/cuchillo/layout/Background';
import InterfaceCanvas from './_app/cuchillo/layout/InterfaceCanvas';
import Header from './layout/Header';
import Loading from './layout/Loading';
import Wrap from './layout/Wrap';
import Cursor from "./_app/cuchillo/cursor/Cursor";

import { ControllerWindow } from './_app/cuchillo/windows/ControllerWindow';
import Win from './_app/cuchillo/windows/Window';
import Preloader from "./layout/Preloader";
import Sidemenu from "./layout/Sidemenu";
import Language from "./_app/cuchillo/utils/Language";
import CMP from "./windows/Cmp";
// import WebGLSketch from "./_app/cuchillo/3D/WebGLSketch";

export default class Main {
  static stats;
  static isInit = false;
  static isToprentInit = false;

  static init() {
    gsap.ticker.fps(60);

    if (this.isInit) return;
    this.isInit = true;

    Basics.id = "TheOne_v000"; // ID para cookies   
    Language.init();

    Header.init();
    Sidemenu.init();
    // ScrollTop.init();
    // WebGLSketch.init();

    Metrics.init(() => Main.resize()); // Tamaños y resize
    Keyboard.enable(); // ESC para cerrar ventana
    Accessibility.init(); // Utils accesibilidad
    // Statics.init(); // Si estamos en debug pinta un FPS counter
    Interaction.init({ ajax: true }) // Posiciones del cursor (Movimiento, click...), Acciones links, drag...
    ControllerWindow.init(); // Control ventanas

    BG.init(CMS_COLORS); // Control de paletas y color de fondo de pantallas. Automatico si añadimos un data-palette='loquesea' en el div con data-page
    InterfaceCanvas.init(); // Canvas de interface, se usa con Cursor
    CMP.init(); // Checkea y saca el aviso de cookies

    Cursor.init();

    LoaderController.add(new PagesLoader()); // Carga/Precarga de paginas HTML
    LoaderController.add(new MediaLoader()); // Carga/Precarga de imgs
    LoaderController.update = progress => Preloader.update(progress);
    LoaderController.onComplete = () => Main.setup();

    // LOOP
    if (isDebug) {
      gsap.ticker.add(() => { Main.loopDebug(); });
    } else {
      this.setWorker();
      this.doCuchilloInfo();
      gsap.ticker.add(() => { Main.loop(); });
    }

    Preloader.init();
    LoaderController.init();
  }

  static setup() {
    this.setupEvents();
    // Main.setupToprentLoader();

    // INIT PAGE
    ControllerPage.init(Wrap.mainholder);
  }

  static setupEvents() {
    EventDispatcher.addEventListener(Page.ON_SHOW, () => {
      Cursor.start();
      Loading.stop();
    });
    EventDispatcher.addEventListener(Page.ON_HIDE, () => {
      Cursor.hide();
      Sidemenu.hide();
    });
    EventDispatcher.addEventListener(Page.ON_HIDE_END, () => {
      Loading.start();
    });

    EventDispatcher.addEventListener(Win.ON_HIDE, () => { Scroll.setEnabled(true); });
    EventDispatcher.addEventListener(Win.ON_SHOW, () => { Scroll.setEnabled(false); });
    EventDispatcher.addEventListener(Sidemenu.ON_HIDE, () => { Scroll.setEnabled(true); });
    EventDispatcher.addEventListener(Sidemenu.ON_SHOW, () => {
      Scroll.setEnabled(false);
      ControllerWindow.hideAll();
    });
  }

  static setupToprentLoader() {
    if (this.isToprentInit) return;

    console.log("SETUP Toprent Loader");

    Cookies.add("toprent_loader", "ok", 720 * 60 * 60 * 1000);
    this.isToprentInit = true;

    const toprentTag = GetBy.selector('[data-toprent-loader]')[0];

    if (toprentTag) {
      let script = document.createElement('script');
      script.src = toprentTag.getAttribute('href');
      script.setAttribute('data-cookieconsent', 'necesary');
      document.body.appendChild(script);
    }
  }

  static resize() {
    Header.resize();
    Sidemenu.resize();
    InterfaceCanvas.resize();
    BG.resize();
    ControllerPage.resize();

    if (isTouch) GetBy.id('Main').style.height = `${Metrics.HEIGHT}px`;
  }

  static loop() {
    if (Scroll.isScrolling) Scroll.loop();

    // ControllerPage.loop();
    BG.loop();
    Header.loop();
    Sidemenu.loop();
    // ScrollTop.loop();
    InterfaceCanvas.loop();
    // WebGLSketch.loop();
  }

  static loopDebug() {
    // Statics.begin();
    this.loop();
    // Statics.end();
  }

  static doCuchilloInfo() {
    console.log('Jose Sentis & Santa Helena');
    console.log('');
    console.log('⟶ http://josesentis.com');
    console.log('⟶ https://www.instagram.com/jose.sentis');
    console.log('');
    console.log('⟶ https://santahelena.agency');
    console.log('⟶ https://www.instagram.com/santahelena.agency');
  }

  static setWorker() {
    if ('serviceWorker' in navigator && !isDebug) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(function () { });
    }
  }
}

if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
  Main.init();
} else {
  document.addEventListener('DOMContentLoaded', Main.init);
}
